// import capitalize from lodash breaks things fow whatever reason... `capitalize is not defined`
const capitalize = (str) => `${str[0].toUpperCase()}${str.slice(1)}`

export const getContentComponentForStepType = function (type) {
  type = type.toLowerCase()
  try {
    const Component = require(`./${type}/${capitalize(type)}`).default
    return Component
  } catch (err) {
    console.error(err)
    throw new Error(`No Content Compontent type ${type} found.`)
  }
}

export const getManageComponentForStepType = function (type) {
  type = type.toLowerCase()
  try {
    return require(`./${type}/manage/Manage${capitalize(type)}`).default
  } catch (err) {
    console.error(err)
    throw new Error(`No Manage Compontent type ${type} found.`)
  }
}
